module.exports = __webpack_public_path__ + "static/media/cover-business-profile.64a88a65.svg";